import * as PIXI from 'pixi.js'
import moment from 'moment'
import Tool from './tool.class'
import { clear } from '../utils'

export default class DrawShieldLine extends Tool {
  update(event, config, container, pixiObj, options, vm) {
    super.update(...arguments)
  }
  mouseDown(event) {}
  mouseUp(event) {}
  mouseWheel(event) {}
  mouseMove(event) {
    const idx = this.getDrawLineIdxs(
      event.offsetX,
      event.offsetX,
      60,
      this.options.width,
    )[0]
    const line = this.config.data.find(item => item.blindIndex === idx)
    this.drawText(
      (event.offsetX / this.options.width) * this.options.rootOptions.width +
        20,
      (event.offsetY / this.options.height) * this.options.rootOptions.height +
        20,
      line &&
        (line.isPermanent
          ? `ID: ${idx}\n到期时间: 永久`
          : `ID: ${idx}\n到期时间: ${moment(
            line.endAt,
            'YYYYMMDDHHmmss',
          ).format('YYYY-MM-DD HH:mm:ss')}`),
    )
  }
  mouseLeave(event) {}
  drawText(x, y, msg) {
    clear(this.container)
    if (!msg) return
    let message = new PIXI.Text(msg, {
      fontFamily: 'Arial',
      fontSize: 18,
      fill: '#409EFF',
    })
    message.position.set(x + 10, y + 10)

    let roundBox = new PIXI.Graphics()
    roundBox.lineStyle(2, 0xcccccc, 1)
    roundBox.beginFill(0xffffff)
    roundBox.drawRoundedRect(0, 0, 300, 64, 4)
    roundBox.endFill()
    roundBox.x = x
    roundBox.y = y
    this.container.addChild(roundBox)

    this.container.addChild(message)
  }
  getDrawLineIdxs(x1, x2, cols, width) {
    if (x1 > x2) {
      ;[x1, x2] = [x2, x1]
    }
    const blockWidth = width / cols
    const startIdxX = Math.floor(x1 / blockWidth)
    const endIdxX = Math.floor(x2 / blockWidth)

    const result = []
    let idxX = startIdxX
    while (true) {
      result.push(idxX++)
      if (idxX > endIdxX) {
        break
      }
    }
    return result
  }
}
